export type MaintenanceConfig = {
  enabled: boolean;
  title: string;
  message: string;
  submessage: string;
  estimatedReturn: string;
};

export const DEFAULT_MAINTENANCE_CONFIG: MaintenanceConfig = {
  enabled: false,
  title: "Estamos en mantenimiento",
  message: "Estamos realizando ajustes para restablecer el servicio con normalidad.",
  submessage: "Regresamos en unos minutos. Gracias por tu paciencia.",
  estimatedReturn: "",
};

export const isMaintenanceEnabledByEnv = () =>
  process.env.REACT_APP_MAINTENANCE_MODE === "true";

export const mergeMaintenanceConfig = (partial?: Partial<MaintenanceConfig>): MaintenanceConfig => ({
  ...DEFAULT_MAINTENANCE_CONFIG,
  ...partial,
});

export const fetchMaintenanceConfig = async (): Promise<MaintenanceConfig> => {
  const baseUrl = process.env.PUBLIC_URL || "";
  const response = await fetch(`${baseUrl}/maintenance.json`, { cache: "no-store" });

  if (!response.ok) {
    return DEFAULT_MAINTENANCE_CONFIG;
  }

  const data = await response.json();
  return mergeMaintenanceConfig(data);
};
